import { subDays, isSameDay, isSameYear, format, isAfter } from 'date-fns';
import getProviderProfileUrl from '@/helpers/providerProfileUrl';

export const getLastMessageDate = (otherUser, lastMessage) => {
  if (otherUser.showDate === false || !lastMessage?.createdAt) return '';

  const timestamp = new Date(lastMessage.createdAt);
  const today = new Date();

  if (isSameDay(timestamp, today)) return format(timestamp, 'h:mm aa');

  const yesterday = subDays(today, 1);
  if (isSameDay(timestamp, yesterday)) return 'Yesterday';

  const pastWeek = subDays(today, 7);
  if (isSameDay(timestamp, pastWeek) || isAfter(timestamp, pastWeek)) return format(timestamp, 'EEEE');

  if (isSameYear(timestamp, today)) return format(timestamp, 'LLL d');

  return format(timestamp, 'LLL d, yyyy');
};

export const getChannelPreviewImage = (otherUser) => (otherUser.image && otherUser.showAvatar ? otherUser.image : '');

export const getChannelPreviewName = (otherUser) => (otherUser.name ? otherUser.name : 'no name');

export const getLastMessageContent = (otherUser, lastMessage) => {
  if (otherUser.bannerMessage) return otherUser.bannerMessage;

  return lastMessage?.message;
};

export const getUnreadMsgLabel = (unreadMessageCount) => {
  if (unreadMessageCount === 1) return '1 unread message';

  return `${unreadMessageCount} unread messages`;
};

export const getActiveChannelClass = (url, currentChannelUrl) => {
  if (url === currentChannelUrl) return 'channel-preview--btn__active';

  return '';
};

export const getProfileLink = (accountType, otherUser) => {
  if (accountType === 'sitter' && !otherUser.accountClosed) {
    return `/open_jobs/${otherUser.correspondingUserId}`;
  }

  if (accountType === 'parent' && !otherUser.accountClosed) {
    return getProviderProfileUrl(otherUser.correspondingUserId, null, otherUser.providerType);
  }

  return null;
};
